<template>
    <div  class="all-height">
        <el-main class="all-height" v-if="flag">
            <div class="operation-bar">
                <h1>已处理订单</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="keyword" placeholder="订单号、采购方、制单人、供货方"/>
                    </div>
                </div>
            </div>

            <div class="table-box cursorPointer">
                <el-table :data="orderList"
                          height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                          @row-dblclick = "rowDblclick"
                          @sort-change = "sortChange"
                >
                    <el-table-column width="150" prop="orderNo" label="订单编号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="150" sortable="custom" prop="oldOrderNo" label="订单编号(旧)" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="120" sortable="custom"  prop="orderDate" label="订单日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="300" sortable="custom" prop="sapToCompName" label="采购方" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="150"  prop="sapMarkerName" label="制单人" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="300"  prop="sapVendorName" label="供货方" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column label="状态" width="150" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag type="success">已处理</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click.stop="printOrder(scope.row)" type="text" size="small">打印订单</el-button>
                            <el-button @click.stop="cancelSign(scope.row)" type="text" size="small">取消签章</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="table-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.current"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>
        <detail :order-id="orderId" :is-lock="isLock" @closeDetail="closeDetail"  v-else></detail>

    </div>

</template>

<script>
import detail from './finish-detail';
const orderReportUrl = 'http://report.craneweihua.com/webroot/decision/view/report?viewlet=wup%252F%25E9%2587%2587%25E8%25B4%25AD%25E8%25AE%25A2%25E5%258D%2595%25E7%25AD%25BE%25E7%25AB%25A0.cpt&ref_t=design&ref_c=479059aa-91d1-48fa-a7a6-7f1182503568&orderId=';
export default {
    name: 'finish-order',
    components: {
        detail
    },
    data() {
        return {
            orderList: [],
            page: {
                current: 1,
                pageSize: 15,
                pageSizes: [15,30,50,100],
                total: 0
            },
            keyword: '',
            orderId: '',
            flag: true,
            isLock: false,
            sort: {
                columnName: '',
                order: ''
            }
        };
    },

    methods: {
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.loadOrderList();
        },

        handleCurrentChange(val) {
            this.page.current = val;
            this.loadOrderList();
        },

        loadOrderList() {
            this.$store.dispatch('order/order/getOrderList', {
                current: this.page.current,
                size: this.page.pageSize,
                keyword: this.keyword,
                status: '1',
                ...this.sort,
            }).then((res)=> {
                this.orderList = res.records;
                this.page.total = res.total;
            })
        },

        query() {
            this.page.current = 1;
            this.loadOrderList();
        },

        rowDblclick(row) {
            this.orderId = row.id;
            this.isLock = row.status !== '0';
            this.flag = !this.flag;
        },

        closeDetail() {
            this.flag = !this.flag;
            // this.query();
            this.loadOrderList();
        },

        printOrder(row) {
            this.$store.dispatch('order/order/setVendorSignInfo', {orderId: row.id}).then((ret)=>{
                if(ret.code === '200'){
                    window.open(orderReportUrl+row.id);
                }else{
                    this.$message.error(ret.data?ret.data : ret.message);
                }
            });
        },
        sortChange(column, prop, order) {
            this.sort.columnName = column.prop;
            this.sort.order = column.order;
            this.loadOrderList();
        },
        cancelSign(row) {
            this.$confirm('取消签章： '+ row.orderNo +', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.$store.dispatch('order/order/cancelSign', {orderId: row.id}).then((res)=>{
                    if(res.data.code === '200') {
                        this.$message.success(res.data.data);
                        this.loadOrderList();
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            });
        }
    },
    created() {
        this.loadOrderList();
    }
}

</script>

<style scoped>
.table-box{
    position: relative;
    margin-top: 5px;
    background-color: white;
    height: calc(100% - 35px);
    width: 100%;
}
.table-page {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
}
.el-table .el-button{
    padding: 0;
}
.cell i {
    font-size: 20px;
    cursor: pointer;
}
.cell i:hover {
    color: #5ED1FD;
}
.textArea-box {
    max-height: 300px;
    overflow-y: scroll;
}
/deep/ .cursorPointer tbody tr:hover {cursor: pointer }
</style>
